import { useState } from 'react';

export default function FotoVideographieFAQ() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  const faqs = [
    {
      question: "Wie lange dauert eine typische Foto- oder Videoproduktion?",
      answer: "Die Dauer hängt vom Umfang des Projekts ab. Ein einfaches Fotoshooting dauert 2-4 Stunden, während komplexere Videoproduktionen 1-3 Tage in Anspruch nehmen können. Wir besprechen den Zeitrahmen im Vorfeld ausführlich mit Ihnen."
    },
    {
      question: "Was kostet ein professionelles Imagevideo?",
      answer: "Die Kosten für ein Imagevideo variieren je nach Länge, Komplexität und Produktionsaufwand. Ein einfaches Imagevideo startet bei ca. 1.500€, während umfangreichere Produktionen mit Drohnenaufnahmen, mehreren Drehtagen und aufwendiger Postproduktion entsprechend mehr kosten. Wir erstellen Ihnen gerne ein individuelles Angebot."
    },
    {
      question: "Wo finden die Foto- und Videoshootings statt?",
      answer: "Wir kommen gerne zu Ihnen vor Ort – ob in Ihrem Unternehmen, bei Events oder an besonderen Locations in Wernigerode und Umgebung. Alternativ können wir auch in unserem Studio arbeiten oder gemeinsam passende Locations auswählen."
    },
    {
      question: "Wie lange dauert es bis zur Lieferung der fertigen Bilder und Videos?",
      answer: "Fotos erhalten Sie in der Regel innerhalb von 5-7 Werktagen nach dem Shooting. Bei Videos beträgt die Bearbeitungszeit je nach Umfang 2-3 Wochen. Für eilige Projekte bieten wir gegen Aufpreis auch Express-Bearbeitung an."
    },
    {
      question: "In welchen Formaten werden die Dateien geliefert?",
      answer: "Fotos liefern wir in hochauflösenden JPEGs, auf Wunsch auch als RAW-Dateien. Videos erstellen wir in Full HD oder 4K in gängigen Formaten wie MP4 oder MOV. Alle Formate werden für Ihren spezifischen Verwendungszweck optimiert – ob für Web, Social Media oder Print."
    },
    {
      question: "Bietet ihr auch Drohnenaufnahmen an?",
      answer: "Ja, wir verfügen über professionelle Drohnen und alle erforderlichen Genehmigungen für Luftaufnahmen in Wernigerode und der Harz-Region. Drohnenaufnahmen eignen sich perfekt für Immobilien, Events, Landschaften oder Unternehmensvideos und verleihen Ihren Inhalten eine besondere Perspektive."
    },
    {
      question: "Kann ich die Bilder und Videos kommerziell nutzen?",
      answer: "Ja, Sie erhalten die vollständigen Nutzungsrechte für alle gelieferten Bilder und Videos. Sie können diese ohne Einschränkungen für Ihre Website, Social Media, Werbematerialien, Kataloge und alle anderen kommerziellen Zwecke verwenden."
    },
    {
      question: "Welche Ausrüstung verwendet ihr?",
      answer: "Wir arbeiten mit professioneller Kameraausrüstung von Canon und Sony, hochwertigen Objektiven, Stabilisatoren, Drohnen und professionellem Licht- und Tonequipment. Unsere Ausrüstung wird regelmäßig aktualisiert, um höchste Qualität zu gewährleisten."
    }
  ];

  return (
    <section className="py-32 bg-black">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <span className="text-[#d1bc8a] text-sm uppercase tracking-[0.3em] font-light mb-6 block">
              FAQ
            </span>
            <h2 className="text-5xl md:text-7xl font-bold text-white mb-6">
              Häufig gestellte
              <br />
              <span className="text-[#d1bc8a]">Fragen</span>
            </h2>
            <p className="text-xl text-white/60 max-w-3xl mx-auto font-light">
              Hier finden Sie Antworten auf die wichtigsten Fragen rund um Foto- und Videoproduktion
            </p>
          </div>

          {/* FAQ Items */}
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white/5 border border-white/10 hover:border-[#d1bc8a]/50 rounded-2xl overflow-hidden transition-all duration-300"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full p-6 text-left flex items-center justify-between hover:bg-white/5 transition-colors cursor-pointer"
                >
                  <h3 className="text-lg font-semibold text-white pr-4">
                    {faq.question}
                  </h3>
                  <div className="flex-shrink-0">
                    <i className={`ri-${openFAQ === index ? 'subtract' : 'add'}-line text-[#d1bc8a] text-xl transition-transform duration-300`}></i>
                  </div>
                </button>
                
                {openFAQ === index && (
                  <div className="px-6 pb-6">
                    <div className="border-t border-white/10 pt-4">
                      <p className="text-white/60 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>


        </div>
      </div>
    </section>
  );
}